import { AbstractControl, UntypedFormGroup, ValidationErrors, Validators } from "@angular/forms";

import { NO_LIMIT } from "../responsible-gaming/deposit-limit/deposit-limit.const";

import { OBG_VALIDATORS } from "./validators";

export const PERIOD_FIELDS = {
	netLoss: "netLossLimitPeriod",
	deposit: "depositLimitPeriod",
	wagering: "bettingLimitType",
};

export const periodLimitAmountValidator =
	(periodControlName: string) =>
	(control: AbstractControl): ValidationErrors | null => {
		if (control.parent) {
			const limitPeriodControl = (control.parent as UntypedFormGroup).controls[periodControlName];
			if (
				limitPeriodControl &&
				!Validators.required(limitPeriodControl) &&
				limitPeriodControl.value !== NO_LIMIT.value
			) {
				const errors = [Validators.required, OBG_VALIDATORS.numericNotZero].reduce(
					(acc, validator) => Object.assign(acc, validator(control)),
					{}
				);
				if (Object.keys(errors).length) {
					return errors;
				}
			}
		}
		return null;
	};
